import React from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../../../components/inputs/TextInput";
import DetailItem from "./DetailItem"; 
import style from "./WorkOrderInfo.module.scss";

const WorkOrderInfoEdit = ({ workOrder, isEditing, onWorkOrderChange }) => {
  const { t } = useTranslation();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onWorkOrderChange((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={style.orderCard}>
      {isEditing ? (
        <>
          <TextInput 
            label={t("workOrder.info.status")} 
            name="status" 
            value={workOrder.status || ""} 
            onChange={handleInputChange} 
            placeholder={t("workOrder.info.enterStatus")} 
          />
          <TextInput 
            label={t("workOrder.info.comment")} 
            name="comment" 
            value={workOrder.comment || ""} 
            onChange={handleInputChange} 
            placeholder={t("workOrder.info.enterComment")} 
          />
          <TextInput 
            label={t("workOrder.info.tax")} 
            name="tax" 
            type="number" 
            value={workOrder.tax || ""} 
            onChange={handleInputChange} 
            placeholder={t("workOrder.info.enterTax")} 
          />
          <TextInput 
            label={t("workOrder.info.issuedOn")} 
            name="issued_on" 
            type="date" 
            value={workOrder.issued_on ? new Date(workOrder.issued_on).toISOString().split("T")[0] : ""} 
            onChange={handleInputChange} 
          />
          <TextInput 
            label={t("workOrder.info.start")} 
            name="start_at" 
            type="datetime-local" 
            value={workOrder.start_at ? new Date(workOrder.start_at).toISOString().slice(0, 16) : ""} 
            onChange={handleInputChange} 
          />
          <TextInput 
            label={t("workOrder.info.end")} 
            name="end_at" 
            type="datetime-local" 
            value={workOrder.end_at ? new Date(workOrder.end_at).toISOString().slice(0, 16) : ""} 
            onChange={handleInputChange} 
          />
        </>
      ) : (
        <div className={style.detailsGrid}>
          <DetailItem label={t("workOrder.info.status")} value={workOrder.status} />
          <DetailItem label={t("workOrder.info.comment")} value={workOrder.comment} />
          <DetailItem label={t("workOrder.info.tax")} value={workOrder.tax} />
          <DetailItem label={t("workOrder.info.issuedOn")} value={new Date(workOrder.issued_on).toLocaleDateString()} />
          <DetailItem 
            label={t("workOrder.info.start")} 
            value={workOrder.start_at ? new Date(workOrder.start_at).toLocaleString() : t("workOrder.info.notSpecified")} 
          />
          <DetailItem 
            label={t("workOrder.info.end")} 
            value={workOrder.end_at ? new Date(workOrder.end_at).toLocaleString() : t("workOrder.info.notSpecified")} 
          />
        </div>
      )}
    </div>
  );
};

export default WorkOrderInfoEdit;
